import { GraphicsInfo } from "./graphics-info";
import { MediaInfo } from "./media";

export class DynamicPromo {
  constructor(
    public id: string,
    public name: string,
    public graphicsId: number,
    public mediaId: number,
    public thumbnail: string = null,
    public startGraphicOffsetSeconds: number = null,
    public trailerId: number = null,
    public isScheduled: boolean = false,
  ) {}
}

export class DynamicPromoInfo {
  constructor(
    public id: string,
    public name: string,
    public graphicsInfo: GraphicsInfo,
    public mediaInfo: MediaInfo,
    public thumbnail: string = null,
    public startGraphicOffsetSeconds: number = null,
    public trailerId: number = null,
  ) {}
}
